import { RouteType } from "routes/types";
import { lazy } from "react";

const Element = lazy(() => import("./index"));

const route: RouteType = {
  id: 300003,
  parentId: 300000,
  name: "DevMarkdown",
  label: "Markdown",
  path: "markdown",
  icon: "form",
  element: Element,
  admin: false,
  hidden: false,
};

export default route;
